<ion-row class="filtros">
  <ion-col size="6">
    <ion-item lines="none" class="input-container">
      <ion-input label="Data Inicio" labelPlacement="floating" [readonly]="true" type="text" class="text-input"
        [(ngModel)]="formFiltro.dataInicio" [id]="id"></ion-input>
      <ion-modal [trigger]="id">
        <ng-template>
          <ion-label>Data Início</ion-label>
          <ion-datetime id="datetimeValue" [presentation]="'date'" mode="ios" [(ngModel)]="selectCalendarStartDate"
            pickerFormat="DD/MM/YYYY" locale="pt-Br" max="2060-01-01" [showDefaultButtons]="true" doneText="OK"
            cancelText="Voltar" (ionChange)="touchSetStartDate()">
          </ion-datetime>
        </ng-template>
      </ion-modal>
    </ion-item>
    <p class="invalidFild" *ngIf="formFiltro.dataInicio.length >= 10 && !isValidDateInitialDate()">
      * Data Inicio inválida!
    </p>
  </ion-col>

  <ion-col size="6">
    <ion-item lines="none" class="input-container">
      <ion-input label="Data Fim" labelPlacement="floating" [readonly]="true" type="text" class="text-input"
        [(ngModel)]="formFiltro.dataFim" [id]="id + 'End'" (ionChnage)="isValidDateFimDate(); updateData()"></ion-input>

      <ion-modal [trigger]="id + 'End'">
        <ng-template>
          <ion-label>Data Fim</ion-label>
          <ion-datetime id="datetimeValue" [presentation]="'date'" mode="ios" [(ngModel)]="selectCalendarEndDate"
            pickerFormat="DD/MM/YYYY" locale="pt-Br" max="2060-01-01" [showDefaultButtons]="true" doneText="OK"
            cancelText="Voltar" (ionChange)="touchSetFinalDate()">
          </ion-datetime>
        </ng-template>
      </ion-modal>

      <!-- <div class="container">
        <ion-popover [trigger]="id + 'End'" alignment="center" side="bottom" swipeToClose="true">
          <ng-template>
            <ion-datetime id="dateEnd" [presentation]="'date'" mode="ios" [(ngModel)]="selectCalendarEndDate"
              locale="pt-Br" pickerFormat="DD/MM/YYYY" max="2060-01-01" [showDefaultButtons]="true" doneText="OK"
              cancelText="Voltar" (ionChange)="touchSetFinalDate()">
            </ion-datetime>
          </ng-template>
        </ion-popover>
      </div> -->
    </ion-item>
    <p class="invalidFild" *ngIf="formFiltro.dataFim.length >= 10 && !isValidDateFimDate()">
      * Data Fim inválida!
    </p>
    <p class="invalidFild" *ngIf="formFiltro.dataFim.length >= 10 && !isDataInferior() && isValidDateInitialDate()">
      * Data fim não pode ser menor que data Inicio!
    </p>
  </ion-col>

</ion-row>